import {isCellInRange} from '../lib/table-ops';
import type {TableFillDrag} from '../hooks/useTableFillDrag';

/**
 * The fill handle's marks on one editor cell: the dashed outline over a cell a
 * release would fill, and the handle itself on the selection's bottom-right
 * cell. The handle sits above the row and column edges that meet at that
 * corner, so a press there fills rather than resizes.
 */
export function CellFillOverlay({
  fill,
  ri,
  ci,
  inRange,
}: {
  fill: TableFillDrag;
  ri: number;
  ci: number;
  /** Whether the cell is in the selection, which the fill never outlines. */
  inRange: boolean;
}) {
  const {preview, corner, start} = fill;
  return (
    <>
      {preview && isCellInRange(preview, ri, ci) && !inRange && (
        <div className="absolute inset-0 pointer-events-none border-2 border-dashed border-indigo-400" />
      )}
      {corner?.endRow === ri && corner.endCol === ci && (
        <div
          data-fill-handle=""
          title="Drag down or right to copy into the cells below or beside"
          className="absolute bottom-0 right-0 h-2 w-2 translate-x-1/2 translate-y-1/2 border border-white bg-indigo-500"
          style={{cursor: 'crosshair', zIndex: 20}}
          onMouseDown={start}
        />
      )}
    </>
  );
}
